import clients from "./clients.json"
import common from "./common.json"
import drivers from "./drivers.json"
import notifications from "./notifications.json"
import orders from "./orders.json"
import payments from "./payments.json"

export const pl = {
  clients,
  common,
  drivers,
  notifications,
  orders,
  payments,
}
